import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { MenuItem, Select } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import DeletePop from "../../../constants/ErrorPermissionModal";
import DyanmicFromMobile from "../../DyanmicForm/DyanmicFromMobile";
import ActionMobileDrop from "../../ActionDropBar/ActionMobileDrop";

const Level2SailingDateInput = ({ data, setData }) => {
  const [activeRow, setActiveRow] = useState(null); // 👈 Track active row
  const [sailingPage, setSailingPage] = useState();
  const handleChange = (index, field, value) => {
    const updatedRows = [...data];
    updatedRows[index][field] = value;
    setData(updatedRows);
  };

  useEffect(() => {
    setSailingPage(JSON.parse(localStorage.getItem("sailing-page") || "{}"));
  }, []);

  const addRow = () => {
    setData([...data, { description: "", start_time: "", end_time: "" }]);
    setActiveRow(data.length); // 👈 new row becomes active
  };

  const deleteRow = (index) => {
    if (data.length > 1) {
      const updatedRows = data.filter((_, i) => i !== index);
      setData(updatedRows);
      if (activeRow === index) setActiveRow(null); // 👈 close if deleted
    }
  };
  let remark = [
    {
      title: "English Description",
      key: "english",
      className: "col-lg-4",
      type: "input",
      required: false,
    },
    {
      title: "Simplified Chinese Description",
      key: "simplified_chinese",
      className: "col-lg-4",
      type: "input",
      required: false,
    },
    {
      title: "Traditional Chinese Description",
      key: "traditional_chinese",
      className: "col-lg-4",
      type: "input",
      required: false,
    },
  ];

  return (
    <div style={{ marginTop: "10px" }} className="col-12 row ">
      {/* Rows */}
      {data?.map((row, index) => (
        <div
          key={index}
          className="row col-12"
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "15px",
            marginLeft: "10px",
            border: "1px solid black",
            borderRadius: "10px",
            padding: "10px",
          }}
          // 👈 click row to activate
        >
          {activeRow === index ? (
            <div className="col-lg-12 row" style={{ marginBottom: "10px" }}>
              {" "}
              <div
                className="col-lg-12"
                style={{
                  borderBottom: "1px solid black",
                  paddingBottom: "10px",
                }}
              >
                <ActionMobileDrop
                  title={`  Opening Hours ${index + 1}`}
                  active={activeRow === index}
                  setActive={() => setActiveRow()}
                  handleDelete={() => deleteRow(index)}
                />
              </div>
              <DyanmicFromMobile
                error={[]}
                rootData={data}
                level={1}
                attributes={remark || []}
                data={row?.["description"] || {}}
                setData={(e) => {
                  handleChange(index, "description", e);
                }}
              />
              <div className="col-2">
                <label>Set Start Time</label>
                <input
                  type="time"
                  className="f_input"
                  value={row.start_time}
                  onChange={(e) =>
                    handleChange(index, "start_time", e.target.value)
                  }
                  style={{ display: "block", padding: "5px" }}
                />
              </div>
              <div className="col-2">
                <label>Set End Time</label>
                <input
                  className="f_input"
                  type="time"
                  value={row.end_time}
                  onChange={(e) =>
                    handleChange(index, "end_time", e.target.value)
                  }
                  style={{ display: "block", padding: "5px" }}
                />
              </div>
            </div>
          ) : (
            <div
              onClick={() => setActiveRow(index)}
              className="col-12"
              style={{ color: "black", fontWeight: "bold", padding: "5px" }}
            >
              <ActionMobileDrop
                title={row?.description?.english || ` Opening Hours ${index + 1}`}
                active={activeRow === index}
                setActive={() => setActiveRow(index)}
                handleDelete={() => deleteRow(index)}
              />
            </div>
          )}
        </div>
      ))}
      <button
        type="button"
        onClick={addRow}
        style={{ maxWidth: "100px", marginLeft: "10px" }}
        className="btn main_submit"
      >
        Add Item
      </button>
    </div>
  );
};

export default Level2SailingDateInput;
